<template>
  <div>
    <h4 v-if="mainStore.bookingSystem.equipes.has_equipes" class="font-weight-bold my-3"><v-icon
        icon="mdi-account-group" color="primary" size="xs-small"></v-icon> Gestion d'équipes</h4>
    <div class="rounded bg-grey_3 pa-3 my-3 bordered" v-for="(equipe, index) in mainStore.bookingSystem.equipes.list"
      :key="index">
      <h5 class="mb-2">{{ equipe.get_entete(index) }}</h5>
      <v-text-field v-model="equipe.nom"
        @change="change_nom_equipe(equipe, $formRules.equipe(equipe.nom, index, mainStore.bookingSystem.equipes.list))"
        label="Nom de l'équipe" hint="Accepté : Majuscules, chiffres, espaces et certains caractères spéciaux"
        :rules="[$formRules.equipe(equipe.nom, index, mainStore.bookingSystem.equipes.list)]"></v-text-field>
      <div v-if="equipe.extra_fields.length > 0">
        <v-row>
          <v-col cols="12" md="6" v-for="(field, index) in equipe.extra_fields" :key="index">
            <v-text-field @change="change_extra_fields(equipe, field)" v-model="field.value" :label="field.label"
              :required="field.required"></v-text-field>
          </v-col>
        </v-row>
      </div>
      <div>
        Nombre de coureurs requis: <b>{{ equipe.coureurs.length }}/{{ equipe.size }}</b>
      </div>
      <div v-if="equipe.coureurs.length < equipe.size">
        <v-alert color="dark-red" variant="tonal" class="mb-2" type="error">
          L'équipe n'est pas complète, il manque encore {{ equipe.size - equipe.coureurs.length }} coureur(s). En
          ajoutant un nouveau participant sur ce parcours, il sera automatiquement ajouté à cette équipe.
        </v-alert>
      </div>
      <div>
        Parcours: <b>{{ equipe.nom_course }}</b>
      </div>
      <div>Coureurs dans l'équipe:</div>
      <div class="mt-2 d-flex flex-wrap">
        <v-chip class="mx-2" color="primary-dark font-weight-bold" v-for="coureur in equipe.coureurs"
          :key="coureur.index">{{ get_coureur_name(coureur) }}</v-chip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';
import { useBookingStore } from "@/stores/bookingStore";


export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
  },
  watch: {
    'bookingStore.inscriptions': {
      deep: true,
      handler() {
        this.mainStore.bookingSystem.equipes.assign_teams();
      },
    },
  },

  methods: {
    change_nom_equipe(equipe, verification) {
      if (verification != true) {
        return;
      }
      for (let i = 0; i < this.bookingStore.inscriptions.length; i++) {
        let inscription = this.bookingStore.inscriptions[i];
        for (let j = 0; j < equipe.coureurs.length; j++) {
          if (equipe.coureurs[j].index == i) {
            inscription.set_equipe_name(equipe.nom);
          }
        }
      }
    },

    change_extra_fields(equipe, field) {
      for (let i = 0; i < this.bookingStore.inscriptions.length; i++) {
        let inscription = this.bookingStore.inscriptions[i];
        for (let j = 0; j < equipe.coureurs.length; j++) {
          if (equipe.coureurs[j].index == i) {
            inscription.set_extra_equipe_fields(field);
          }
        }
      }
    },


    get_coureur_name(coureur) {
      if (coureur.name != "" && coureur.name != " ") {
        return coureur.name;
      } else {
        return "Coureur  n°" + (coureur.index + 1);
      }
    },

  },
};
</script>

<style lang="scss" scoped></style>